
import { Box, Button, Typography } from '@mui/material';
import { PaperBox } from '../../../../../../../components/Layout/PaperBox'
import { IDetalharPrescricao } from '../../../../../../../types/api/receituarioAgronomico/detalhar-prescricoes';
import { TableSimples } from '../../../../../../../components/BasicComponents/DisplayDados/TableSimples';
import { useState } from 'react';
import DialogPragas from './DialogPragas';

export default function CardPragas({ detalhe }: CardPragasProps) {

    const [openDialog, setOpenDialog] = useState(false)
    return (
        <PaperBox>
            <Typography variant="h6" gutterBottom>
                Pragas
            </Typography>
            {
                detalhe.pragas && detalhe.pragas.length > 0 &&
                <TableSimples
                    headers={[
                        { label: "Nome" },
                        { label: "Nome Científico", numeric: true }
                    ]}
                    rows={detalhe.pragas.slice(0, 5).map(row => ({
                        columns: [
                            { value: row.nome_popular },
                            { value: row.nome_cientifico, numeric: true }
                        ]
                    }))}
                    total={
                        detalhe.pragas.length > 0
                            ? {
                                label: '',
                                value: `+ ${detalhe.pragas.length - 5} registro(s)`,
                                monetary: false
                            }
                            : undefined
                    }
                />
            }
            <Box display="flex" justifyContent="flex-end" mt={1}>
                <Button
                    variant="outlined"
                    size="small"
                    disabled={detalhe.pragas.length === 0}
                    onClick={() => setOpenDialog(true)}
                >
                    Ver mais
                </Button>
            </Box>
            {
                openDialog &&
                <DialogPragas
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    pragas={detalhe.pragas}
                />
            }
        </PaperBox>
    )
}

interface CardPragasProps {
    detalhe: IDetalharPrescricao;
}